__turbopack_context__.v({
  "follow-button--compact": "FollowButton-module-scss-module__VFKGXq__follow-button--compact",
  "follow-button--following": "FollowButton-module-scss-module__VFKGXq__follow-button--following",
  "follow-button--mini": "FollowButton-module-scss-module__VFKGXq__follow-button--mini",
  "follow-button--solitary": "FollowButton-module-scss-module__VFKGXq__follow-button--solitary",
});
